import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./header.scss";
import Div from "../Div";
import { Switch } from "@mui/material";
import { Icon } from "@iconify/react";
import { useThemeContext } from "../../context/AppProvider";

export default function Header({ variant }) {
  const [isSticky, setIsSticky] = useState(false);
  const theme = useThemeContext();

  // const [sideHeaderToggle, setSideHeaderToggle] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);

  const handleChange = (event) => {
    theme.setMode(event.target.checked);
  };

  const logo = theme.mode
    ? "/images/logo/betca_logo.png"
    : "/images/logo/betca_logo_poster.png";

  const paths = [
    {
      path: "/",
      label: "Home",
    },
    {
      path: "/about",
      label: "About",
    },
    {
      path: "/companies",
      label: "Companies",
    },
    {
      path: "https://jobs.betca.org/",
      label: "Jobs",
      external: true,
    },
    {
      path: "/contact",
      label: "Contact Us",
    },
    {
      path: "https://docs.google.com/forms/d/e/1FAIpQLScwHJd0MKUYhJVZrYCdF7SS7JGfx2vHoXgMeaFadta22GGVNA/viewform",
      label: "Be a Patron",
      external: true,
    },
    {
      path: "/twin-finder",
      label: "Twin Finder",
    },
  ];

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    });
  });

  return (
    <header
      className={`cs-site_header cs-style1 text-uppercase ${
        variant ? variant : ""
      } cs-sticky_header ${isSticky ? "cs-sticky_header_active" : ""}`}
      style={{
        backgroundColor: theme.mode ? "black" : "white",
        color: theme.mode ? "white" : "black",
      }}
    >
      <Div className="cs-main_header">
        <Div className="container">
          <Div className="cs-main_header_in">
            <Div className="cs-main_header_left">
              <Link to="/">
                <img src={logo} alt="BeTCA" width={90} />
              </Link>
            </Div>
            <Div className="cs-main_header_center">
              <Div className="cs-nav cs-primary_font cs-medium">
                <ul
                  className="cs-nav_list"
                  style={{
                    display: `${mobileToggle ? "block" : "none"}`,
                    color: theme.mode ? "white" : "black",
                  }}
                >
                  {paths.map((item, i) => (
                    <li key={i}>
                      <NavLink
                        to={item.path}
                        target={item.external && "_blank"}
                        onClick={() => setMobileToggle(false)}
                      >
                        {item.label}
                      </NavLink>
                    </li>
                  ))}
                  <li>
                    <Div
                      style={{
                        height: "100%",
                        width: 110,
                        boxShadq: "1px",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "18px",
                        padding: "1.2px 1px",
                        marginLeft: 2,
                      }}
                    >
                      <Switch
                        checked={theme.mode}
                        onChange={handleChange}
                        value={theme.mode}
                      />
                      <Icon
                        icon={theme.mode ? "ph:moon-fill" : "tabler:sun-filled"}
                        color={theme.mode ? "white" : "black"}
                        width="30"
                        height="30"
                        style={{ marginTop: "4px" }}
                      />
                    </Div>
                  </li>
                </ul>
                <span
                  className={
                    mobileToggle
                      ? "cs-munu_toggle cs-toggle_active"
                      : "cs-munu_toggle"
                  }
                  onClick={() => setMobileToggle(!mobileToggle)}
                >
                  <span></span>
                </span>
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
    </header>
  );
}
